<div class="rename-query-dialog">
  <form nz-form [formGroup]="renameForm" (ngSubmit)="onSave()">
    <nz-form-item>
      <!--  -->
      <nz-form-label [nzSpan]="24" nzRequired nzFor="queryName">Query Name</nz-form-label>
      <nz-form-control [nzSpan]="24" [nzValidateStatus]="renameForm.get('queryName')!" [nzErrorTip]="renameForm.get('queryName')?.hasError('required') ? 'Please enter Query Name' : renameForm.get('queryName')?.hasError('pattern') ? 'Only alphnumric are allowed'  : renameForm.get('queryName')?.hasError('minlength') ? 'Minimum 3 characters required': renameForm.get('queryName')?.hasError('maxlength') ? 'Maximum 100 characters allowed' : ''">
      <input
          nz-input
          formControlName="queryName"
          id="queryName"
          placeholder="Enter a new name for your query"
          autocomplete="off"
          maxlength="100"
        />
      </nz-form-control>
    </nz-form-item>

    <div class="dialog-footer">
      <button nz-button nzType="default" type="button" (click)="onCancel()" [disabled]="loading">
        Cancel
      </button>
      <button nz-button nzType="primary" type="submit" [nzLoading]="loading">
        OK
      </button>
    </div>
  </form>
</div>
